import { RecurrenceValue } from "@/constants/Schedule";
import { BookingStepTestID, BookingTestID } from "@/constants/TestID";

const BookingStepTitleMap: Record<BookingStep, string> = {
  attendees: "The following people will be invited to this appointment",
  availability: "Please choose from one of the following times",
  confirmation: "Please review the details of your appointment:",
  duration: "How long would you like to meet?",
  optionalAttendees: "Who else would you like to invite to this appointment?",
  patient: "Which patient is this appointment for?",
  provider: "Who would you like to book an appointment with?",
  recurrence: "Would you like to book a recurring appointment?",
  sessionType: "What kind of session would you like to book?",
};

const BookingStepBaseTestIDMap: Record<BookingStep, string> = {
  attendees: `${BookingTestID.Primary}-${BookingStepTestID.Attendees}`,
  availability: `${BookingTestID.Primary}-${BookingStepTestID.Availability}`,
  confirmation: `${BookingTestID.Primary}-${BookingStepTestID.Confirmation}`,
  duration: `${BookingTestID.Primary}-${BookingStepTestID.Duration}`,
  optionalAttendees: `${BookingTestID.Primary}-${BookingStepTestID.OptionalAttendees}`,
  patient: `${BookingTestID.Primary}-${BookingStepTestID.Patient}`,
  provider: `${BookingTestID.Primary}-${BookingStepTestID.Provider}`,
  recurrence: `${BookingTestID.Primary}-${BookingStepTestID.Recurrence}`,
  sessionType: `${BookingTestID.Primary}-${BookingStepTestID.SessionType}`,
};

const BookingStepValue: Record<BookingStep, BookingStep> = {
  attendees: "attendees",
  availability: "availability",
  confirmation: "confirmation",
  duration: "duration",
  optionalAttendees: "optionalAttendees",
  patient: "patient",
  provider: "provider",
  recurrence: "recurrence",
  sessionType: "sessionType",
};

const AppointmentRecurrenceOptions: BookingRecurrenceOption[] = [
  {
    id: "one-time-appointment",
    name: "One-time appointment",
    recurrence: RecurrenceValue.DoesNotRepeat,
  },
  {
    id: "recurring-weekly",
    name: "Recurring weekly",
    recurrence: RecurrenceValue.Weekly,
  },
  {
    id: "recurring-biweekly",
    name: "Recurring every other week",
    recurrence: RecurrenceValue.Biweekly,
  },
];

const BookingAvailability = {
  maxAvailabilityWeeks: 8,
  searchRangeInWeeks: 2,
};

enum AppointmentStatus {
  Cancelled = "cancelled",
  Completed = "completed",
  Scheduled = "scheduled",
}

export {
  AppointmentRecurrenceOptions,
  AppointmentStatus,
  BookingAvailability,
  BookingStepBaseTestIDMap,
  BookingStepTitleMap,
  BookingStepValue,
};
